export const ESTATE_LIMITS = {
  BASIC: 1,
  STANDARD: 2,
  PREMIUM: 5,
  PROFESSIONAL: 15,
} as const;

export function getEstateLimit(membership?: string | null) {
  if (!membership) return null;

  return ESTATE_LIMITS[membership as keyof typeof ESTATE_LIMITS] ?? null;
}

export function hasReachedEstateLimit(
  estateCount: number,
  membership?: string | null,
) {
  const limit = getEstateLimit(membership);
  return limit != null && estateCount >= limit;
}
